import { Link, Tooltip } from "@chakra-ui/react"

import { isNotNullNorUndefined } from "@/utils/ts-utils"
import { PhoneIcon, WhatsAppIcon } from "../Icons"
import { P3 } from "../Typographies"

type Props = {
  phone?: string | null
  dft?: string
  smaller?: boolean
  withIcon?: boolean
  allowWhatsApp?: boolean
}

export default function FormattedPhone({ phone, dft, smaller, withIcon, allowWhatsApp }: Props) {
  const Element = () =>
    isNotNullNorUndefined(phone) ? (
      <>
        <Link href={`tel:${phone.replace(/(\([^\)]*\)|[ .\-]+)/g, "")}`} target="_blank">
          {smaller ? <P3>{phone}</P3> : phone}
        </Link>
        {allowWhatsApp && (
          <Tooltip label="Allow WhatsApp">
            <Link
              href={`https://wa.me/${phone.replace(/(^[+0]+|\([^\)]*\)|[ .\-]+)/g, "")}`}
              target="_blank"
            >
              <WhatsAppIcon boxSize={3} ml={2} />
            </Link>
          </Tooltip>
        )}
      </>
    ) : (
      <>{dft ?? ""}</>
    )

  return withIcon ? (
    <>
      <PhoneIcon boxSize="4" color="textSubtle" />
      <Element />
    </>
  ) : (
    <Element />
  )
}
